import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const addUserTag = async ({ testCaseResultId, tag, comment }) => {
  try {
    const userDetailsString = localStorage.getItem("userDetail");

    if (!userDetailsString) {
      throw new Error("No User details found in localStorage");
    }

    const user = JSON.parse(userDetailsString);

    const url = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`;
    const params = {
      action: "saveUserNoteToTCResult",
      testCaseResultId,
      token: user.token,
    };

    const response = await axios.post(
      url,
      {
        userNote: tag,
        userComments: comment,
      },
      { params },
    );

    return response.data;
  } catch (error) {
    console.error("Error adding user tag:", error);
    throw error;
  }
};

const useAddUserTag = (options = {}) => {
  return useMutation({
    mutationFn: addUserTag,
    ...options,
  });
};

export default useAddUserTag;
